<div
    class="form-label border-0 p-1 ms-0 ps-0 text-start position-relative"
    [class.has-password-toggle]="isPassword"
>
    <input
        [id]="'static_' + label + '_' + _index"
        type="text"
        class="form-control input_default"
        [ngClass]="classCustom"
        aria-describedby="emailHelp"
        [type]="isPassword && passwordVisible ? 'text' : type"
        [placeholder]="placeHolder | translate"
        [value]="value"
        (input)="emit(getValue($event))"
    />
    <button
        *ngIf="isPassword"
        type="button"
        class="password-toggle"
        [attr.aria-label]="
            (passwordVisible ? 'input.hidePassword' : 'input.showPassword')
                | translate
        "
        [attr.aria-pressed]="passwordVisible"
        (click)="togglePasswordVisibility()"
    >
        <svg
            *ngIf="!passwordVisible"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        >
            <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
            <circle cx="12" cy="12" r="3" />
        </svg>
        <svg
            *ngIf="passwordVisible"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        >
            <path
                d="M17.94 17.94A10.07 10.07 0 0 1 12 19c-6.5 0-10-7-10-7a18.45 18.45 0 0 1 5.06-5.94"
            />
            <path
                d="M9.9 4.24A9.12 9.12 0 0 1 12 4c6.5 0 10 7 10 7a18.5 18.5 0 0 1-2.16 3.19"
            />
            <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
            <line x1="2" y1="2" x2="22" y2="22" />
        </svg>
    </button>
    <ng-template>
        <div
            class="valid-tooltip"
            *ngIf="showIsValidLabel"
            [innerHtml]="isValidFeedBack || label + '_valid'"
        ></div>
        <div
            class="invalid-tooltip"
            *ngIf="showIsInValidLabel"
            [innerHtml]="isInvalidFeedBack || label + '_invalid'"
        ></div>
    </ng-template>
</div>
